import React from 'react'
import styled, { css } from 'styled-components'
import { Link } from 'gatsby-link'
import Button from '@/components/atoms/Button/Button'

const Style = styled.div`
  border-radius: 12px;
  border-width: 1px;
  overflow: hidden;
  position: relative;

  display: flex;
  flex-direction: row;
  min-height: 390px;

  @media (max-width: 1263px) {
    flex-direction: column;
  }

  & > div:nth-child(1) {
    flex: 1;
  }

  & > div:nth-child(2) {
    flex: 1;
    height: 100%;
    width: 100%;

    @media (max-width: 1263px) {
      order: -1;
    }

    ${(props) =>
      props.reverse
        ? css`
            order: -1;
          `
        : ''};
  }
`

const SimpleContentPicture = ({
  reverse,
  link,
  title,
  content,
  imageElement,
  IconComponent,
  ...rest
}) => {
  return (
    <>
      <Style
        {...rest}
        reverse={reverse}
        className="bg-white text-gray-800 flex items-center"
      >
        <div id="flex-child-1">
          <div className="p-[32px] lg:py-[24px] lg:px-[64px]">
            <div className="pb-[24px]">
              <Link to={link.link}>
                {IconComponent && (
                  <IconComponent customCss="h-[62px] w-[85px]" />
                )}
                <h4
                  className={`text-gray-1100 text-3xl lg:text-4xl font-semibold${
                    IconComponent ? ' pt-[24px]' : ''
                  }`}
                >
                  {title}
                </h4>
              </Link>
            </div>

            <p className="text-base pb-[24px]">{content}</p>

            {link && (
              <Button
                className="bg-white text-gray-800"
                flex
                style={{
                  display: 'inline-block',
                  width: 'auto',
                  'white-space': 'nowrap',
                  height: '52px',
                  background: 'white',
                  color: '#4D657F',
                  border: '1px solid #BFCBDA',
                  'border-radius': '6px',
                  padding: '10px 24px'
                }}
              >
                <a href={link.link}>{link.text}</a>
              </Button>
            )}
          </div>
        </div>

        <div id="flex-child-2">{imageElement}</div>
      </Style>
    </>
  )
}

export default SimpleContentPicture
